/**
 * SelectFieldSettings - выбор из вариантов (кнопки или dropdown)
 */
import React from 'react';
import Icon from '../../../components/AppIcon';

export default function SelectFieldSettings({
  label,
  value,
  onChange,
  options = [], // [{ value: 'left', label: 'Слева', icon: 'AlignLeft' }]
  mode = 'buttons', // 'buttons' | 'dropdown' | 'grid'
  columns = 2, // для grid
}) {
  if (mode === 'dropdown') {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium mb-1">{label}</label>
        )}
        <select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  const gridClass = mode === 'grid'
    ? `grid grid-cols-${columns} gap-2`
    : 'flex gap-2';

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium mb-2">{label}</label>
      )}
      <div className={gridClass}>
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`flex-1 py-2 px-3 rounded-lg border transition-colors text-sm ${
              value === option.value
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border hover:border-primary/50'
            }`}
          >
            {option.icon ? (
              <Icon name={option.icon} size={18} className="mx-auto" />
            ) : (
              option.label
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
